export const getAllRoles = (limit, offset) => {
  return `
    SELECT 
      Id, 
      Name 
    FROM 
      UserRole
    ORDER BY
      Name
      LIMIT ${limit}
      OFFSET ${offset}
      `;
};
